module.exports = __webpack_public_path__ + "static/media/heart-check.eeb80b37.svg";